export default __webpack_public_path__ + "static/fayo-logo-d00061c34f0f0c29cba9dcf74f306693.svg";